import {Injectable} from '@angular/core'
import {Router, NavigationEnd} from '@angular/router'
import {TerminalData} from '@app/core/services/terminal/terminal-data.interface'
import {Order} from '@app/core/services/order/order.interface'
import {RegistrationEntry} from '@app/core/services/contract/registration-entry.interface'
import {BehaviorSubject} from 'rxjs'
import {filter, map} from 'rxjs/operators'

type SelectionType = TerminalData[] | Order[] | RegistrationEntry[]

@Injectable()
export class SelectionService {
  private selectionMap = new Map<string, SelectionType>()
  private currentRoute: string = ''
  private alternativeRoute: string
  private dataSubject: BehaviorSubject<SelectionType> =
    new BehaviorSubject<SelectionType>([])

  constructor(private router: Router) {
    this.router.events
      .pipe(
        map((e: any) => (e.routerEvent ? e.routerEvent : e)),
        filter((event) => event instanceof NavigationEnd),
      )
      .subscribe((event: any) => {
        this.currentRoute = event.urlAfterRedirects
        this.updateSelectionForCurrentRoute()
      })
  }

  private getRouteKey(route: string): string {
    //specific for bulk actions
    return route.startsWith('/terminals/bulk/') ? '/terminals/bulk' : route
  }

  setSelected(data: any) {
    const routeKey = this.getCleanRoute(this.getRouteKey(this.currentRoute))
    this.selectionMap.set(routeKey, [...data])
    this.updateSelectionForCurrentRoute()
    return this.getSelected()
  }

  getSelected(selectedRoute?: string): SelectionType {
    const routeKey = this.getCleanRoute(
      this.getRouteKey(selectedRoute || this.currentRoute),
    )
    return this.selectionMap.get(routeKey) || []
  }

  getSelectedSubject(): BehaviorSubject<SelectionType> {
    return this.dataSubject
  }

  isSelected(itemId: string | number): boolean {
    const currentSelection = this.getSelected()
    return (currentSelection as any[]).some(
      (item) => (item as any).id === itemId,
    )
  }

  private updateSelectionForCurrentRoute(): void {
    const currentSelection = this.alternativeRoute
      ? this.getSelected(this.alternativeRoute)
      : this.getSelected()

    this.dataSubject.next(currentSelection)
  }

  private getCleanRoute(route: string): string {
    return route.split('?')[0] // Remove query parameters
  }
}
